import { render } from "./mscit_survey.vue?vue&type=template&id=b338de18&scoped=true"
import script from "./mscit_survey.vue?vue&type=script&lang=js"
export * from "./mscit_survey.vue?vue&type=script&lang=js"

import "./mscit_survey.vue?vue&type=style&index=0&id=b338de18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b338de18"]])

export default __exports__